const refrigeratorDetailedRateCard = {
  key: "refrigerator",
  title: "Refrigerator Detailed Rate Card",
  note:
    "Indicative refrigerator pricing. Final pricing depends on cooling system issues, compressor condition, parts, and refrigerator size.",
  sections: [
    {
      title: "Inspection",
      items: [
        { name: "Cooling / performance inspection", price: "₹249 visit" },
      ],
    },
    {
      title: "Repair Support",
      items: [
        { name: "Door / gasket issue", price: "₹349 onwards" },
        { name: "Water leakage check", price: "₹349 onwards" },
        { name: "Cooling issue repair direction", price: "Post inspection" },
      ],
    },
    {
      title: "Installation",
      items: [
        { name: "Refrigerator setup / installation", price: "₹399" },
      ],
    },
  ],
};

export default refrigeratorDetailedRateCard;